import { Typography, Segmented } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useLanguageStore } from '../../../store/languageStore';
import { clientProfileApi } from '../../../api/clientProfileApi';
import { LANGUAGE_OPTIONS } from '../../../i18n/languageOptions';
import { telegram } from '../../../utils/telegram';
import type { LanguageCode } from '../../../types/i18n';

interface LanguageSwitcherProps {
  supportedLanguages: LanguageCode[];
}

export function LanguageSwitcher({ supportedLanguages }: LanguageSwitcherProps) {
  const { currentLanguage, setLanguage } = useLanguageStore();

  if (supportedLanguages.length <= 1) return null;

  const options = LANGUAGE_OPTIONS
    .filter((opt) => supportedLanguages.includes(opt.value))
    .map((opt) => ({ label: `${opt.flag} ${opt.label}`, value: opt.value }));

  const handleChange = (value: string | number) => {
    const lang = value as LanguageCode;
    setLanguage(lang);
    telegram.hapticFeedback.impact('light');
    void clientProfileApi.updateLanguage(lang).catch(() => {
      // fire-and-forget — ignore error
    });
  };

  return (
    <div style={{
      borderRadius: 16,
      background: 'var(--bl-surface, #fff)',
      border: '1px solid var(--bl-divider, #ebebeb)',
      overflow: 'hidden',
      marginBottom: 12,
      padding: '12px 16px',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        <GlobalOutlined style={{ color: 'var(--bl-text-muted, #6b7280)', fontSize: 16 }} />
        <Typography.Text style={{ fontSize: 14, fontWeight: 600, color: 'var(--bl-text-strong, #0f172a)' }}>
          Interfeys tili
        </Typography.Text>
      </div>
      <Segmented
        value={currentLanguage}
        options={options}
        onChange={handleChange}
        block
        style={{ borderRadius: 10 }}
      />
    </div>
  );
}
